import React from "react";

import { useTranslate } from "../../hooks/useTranslate";

import Seo from "../seo";
import Barra from "../Barra";
import Button from "../Button";
import BlackBox from "../BlackBox";
import TextImageTalents from "../TextImageTalents";
import GreatPlaceToWork from "../GreatPlaceToWork";
import { TextContainer } from "../TextContainer";
import { SimpleCard } from "../SimpleCard";
import { Heading } from "../Heading";
import { Layout } from "../Layout";
import { Hero } from "../Hero";
import { Jobs } from "../Jobs";

import styled from "styled-components";

import image from "../../../static/images/talentos-axur-venha-com-a-gente-fazer-da-internet-um-lugar-mais-seguro.jpg";

export function TalentsPage() {
  const { t } = useTranslate("talents");

  return (
    <Layout layoutName="page-talents">
      <Seo
        title={t("title_page")}
        description={t("title")}
        metaImage={image}
        urlPage="talentos"
      />
      <Hero>
        <TextContainer>
          <Heading as="h1" size="large">
            {t("title")}
          </Heading>

          <p>{t("text")}</p>

          <Button typeButton="scroll-to" goTo="#jobs">
            {t("btn")}
          </Button>
        </TextContainer>
      </Hero>

      <GreatPlaceToWork />

      <Barra />

      <TextImageTalents />

      <BlackBox blackBoxType="talents" />

      <CulturalValuesWrapper>
        <Heading>{t("core_values.title")}</Heading>
        <Values>
          <SimpleCard
            titleCheck
            title="Customer first"
            text={t("core_values.text_1")}
          />
          <SimpleCard
            titleCheck
            title="Passion for smart results"
            text={t("core_values.text_7")}
          />
          <SimpleCard
            titleCheck
            title="World-class team"
            text={t("core_values.text_8")}
          />
          <SimpleCard
            titleCheck
            title="True ownership"
            text={t("core_values.text_6")}
          />
        </Values>
      </CulturalValuesWrapper>
      <Jobs />
    </Layout>
  );
}

const CulturalValuesWrapper = styled.section`
  width: min(80%, 1440px);
  margin-inline: auto;

  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 64px 48px;

  @media only screen and (max-width: 767px) {
    width: min(100%, 1440px);
    padding: 48px;
  }

  @media only screen and (max-width: 500px) {
    padding: 24px;
  }
`;

const Values = styled.div`
  width: min(80%, 1248px);
  margin-top: 96px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 48px 112px;
`;
